import React from 'react';
import { MdOutlineBusinessCenter } from 'react-icons/md';
import FinanceNavSection from './FinanceNavSection';
import InventoryNavSection from './InventoryNavSection';
import ProcurementNavSection from './ProcurementNavSection';
import CateringNavSection from './CateringNavSection';
import { hasAdministrationDesktopAccess } from './adminNavConfig';

/**
 * Company-level Administration group (Finance, Procurement, Inventory, Catering).
 * HR is intentionally excluded and remains a root-level menu item.
 */
export default function AdministrationNavSection({
  MenuItem,
  SubMenuItem,
  showCompanyMenu,
  isAdmin,
  hasMenuAccess,
  hasMenuAccessOrChild,
  activeProject,
  hasApprovedBudget,
  ...menuPrimitives
}) {
  const accessCtx = {
    showCompanyMenu,
    isAdmin,
    hasMenuAccess,
    hasMenuAccessOrChild,
  };

  if (!hasAdministrationDesktopAccess(accessCtx)) return null;

  const nestedProps = { nested: true, ...menuPrimitives, hasMenuAccess, hasMenuAccessOrChild, activeProject, hasApprovedBudget };

  return (
    <div data-tour="administration-nav">
      <MenuItem
        customIcon={<MdOutlineBusinessCenter style={{ width: '24px', height: '24px' }} />}
        title="Administration"
        id="administration"
      >
        {SubMenuItem && (
          <SubMenuItem to="/administration">Overview</SubMenuItem>
        )}
        {showCompanyMenu('finance') && isAdmin && (
        <FinanceNavSection {...nestedProps} />
      )}
      {showCompanyMenu('supply-chain') && (
        <ProcurementNavSection {...nestedProps} />
      )}
      {showCompanyMenu('inventory') && (
        <InventoryNavSection {...nestedProps} />
      )}
      {showCompanyMenu('catering') && (
        <CateringNavSection {...nestedProps} />
      )}
      </MenuItem>
    </div>
  );
}
